import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Label,
  Dropdown,
  TextArea
} from 'semantic-ui-react'

const CardSpecialEquipmentUX = (props: any) => {
    return(
      <div
        id="CardSpecialEquipment"
        style={{ margin: "15px",  padding: "20px",  backgroundColor: "rgba(198, 235, 243, 0.2)" }}>
        <div
          id="CardSpecialEquipmentUX-div-1"
          style={{ paddingBottom: "5px" }}>
          
          <label
            id="CardSpecialEquipmentUX-label-2"
            style={{ fontWeight: "bold", fontSize: "18px" }}>
            {props.languageUX === "en" ? "Special Equipment" : "Special Equipment"}
          </label>
          <Label
            color={props.statusColor}
            id="CardSpecialEquipmentUX-Label-3"
            style={{ float: "right", display: "none" }}>
            {props.status}
          </Label>
          <hr
            id="CardSpecialEquipmentUX-hr-4">
          </hr>
        </div>
        <div
          id="CardSpecialEquipmentUX-div-21"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSpecialEquipmentUX-div-22"
            style={{width:"100%",margin: "5px 10px 0px 0px", }}>
            
            <Dropdown
              fluid={true}
              id="CardSpecialEquipmentUX-Dropdown-157"
              multiple={true}
              name="special_equipments"
              onChange={props.onChangeData}
              options={props.specialEquipmentOptions || []}
              selection={true}
              value={props.specialEquipment || []}>
            </Dropdown>
          </div>
        </div>
        <div
          id="CardSpecialEquipmentUX-div-159"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSpecialEquipmentUX-div-160"
            style={{width:"100%",margin: "5px 10px 0px 0px", }}>
            
            <label
              id="CardSpecialEquipmentUX-label-162"
              style={{ fontWeight: "bold" }}>
              {props.languageUX === "en" ? "Special Equipment Detail" : "Special Equipment Detail"}
            </label>
          </div>
        </div>
        <div
          id="CardSpecialEquipmentUX-div-164"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            className="ui form"
            id="CardSpecialEquipmentUX-div-165"
            style={{width:"100%",margin: "5px 10px 0px 0px", }}>
            
            <TextArea
              id="CardSpecialEquipmentUX-TextArea-167"
              name="detail.special_equipments_detail_other"
              onChange={props.onChangeData}
              rows={7}
              style={{ width: "100%" }}
              value={props.specialEquipmentOtherData}>
            </TextArea>
          </div>
        </div>
        <div
          id="CardSpecialEquipmentUX-div-154"
          style={{ height: "55px", paddingTop: "15px" }}>
          
          <div
            id="CardSpecialEquipmentUX-div-155"
            style={{ float: "right" }}>
            
            <div
              id="CardSpecialEquipmentUX-div-158">
              {props.ButtonSave}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardSpecialEquipmentUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Thu Nov 20 2025 07:17:10 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSpecialEquipment"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\",  padding: \"20px\",  backgroundColor: \"rgba(198, 235, 243, 0.2)\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"5px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "Special Equipment",
          "valueEN": "Special Equipment"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-label-2"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"18px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Label",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.status"
        },
        "color": {
          "type": "code",
          "value": "props.statusColor"
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-Label-3"
        },
        "style": {
          "type": "code",
          "value": "{ float: \"right\", display: \"none\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-hr-4"
        }
      },
      "seq": 4,
      "void": true
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\",margin: \"5px 10px 0px 0px\", }"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-div-154"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"55px\", paddingTop: \"15px\" }"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-div-155"
        },
        "style": {
          "type": "code",
          "value": "{ float: \"right\" }"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "Dropdown",
      "parent": 22,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-Dropdown-157"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "special_equipments"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.specialEquipmentOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.specialEquipment || []"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": null,
      "id": 158,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSave"
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-div-158"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": null,
      "id": 159,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-div-159"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": null,
      "id": 160,
      "name": "div",
      "parent": 159,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-div-160"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\",margin: \"5px 10px 0px 0px\", }"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "label",
      "parent": 160,
      "props": {
        "children": {
          "type": "value",
          "value": "Special Equipment Detail",
          "valueEN": "Special Equipment Detail"
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-label-162"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 164,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-div-164"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 165,
      "name": "div",
      "parent": 164,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-div-165"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\",margin: \"5px 10px 0px 0px\", }"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "TextArea",
      "parent": 165,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSpecialEquipmentUX-TextArea-167"
        },
        "name": {
          "type": "value",
          "value": "detail.special_equipments_detail_other"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "code",
          "value": "7"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.specialEquipmentOtherData"
        }
      },
      "seq": 167,
      "void": true
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardSpecialEquipmentUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
